import moment from "moment";

import scheduleNotStarted from "../../../../../../public/images/access-screens/scheduleNotStarted.svg";

import { useAppSelector } from "@assessment/store/store";
import type { RootState } from "@assessment/store/store";
import { ParseDateString } from "@lxp-app/utils/parse-date-string/parseDateString";
import { useTranslation } from "react-i18next";

interface Props {
  allowedAfter?: string;
  coolOffTime?: string;
  orgBasedFeatureName?: string;
}

const CoolOffPeriodScreen = ({
  allowedAfter,
  coolOffTime,
  orgBasedFeatureName = "assessment"
}: Props) => {
  const { t } = useTranslation();
  const user = useAppSelector((state: RootState) => state.UserInfoSlice);

  const userTZ = user.profile?.preferences?.timezone || "UTC";

  const now = moment();
  const allowedMoment = moment(allowedAfter);

  const diffHours = allowedMoment.diff(now, "hours", true);

  return (
    <div className="flex flex-col justify-center items-center space-y-5 text-center w-full py-10">
      <img
        src={scheduleNotStarted}
        alt={t("assessment.accessScreens.coolOffPeriod.alt")}
        className="w-[150px] h-[150px] lg:w-[350px] lg:h-[350px] object-cover"
      />

      <div className="max-w-[800px]">
        <h1 className="text-2xl text-primary font-bold">
          {t("assessment.accessScreens.coolOffPeriod.title")}
        </h1>

        <p className="mt-5 text-primary text-base">
          {t("assessment.accessScreens.coolOffPeriod.completedAttempt", {
            featureName: orgBasedFeatureName
          })}{" "}
          <span>{orgBasedFeatureName}</span>
          {coolOffTime && allowedAfter ? (
            <>
              {" "}
              {t(
                "assessment.accessScreens.coolOffPeriod.nextAttemptIntro"
              )}{" "}
              <span className="font-bold">{coolOffTime}</span> on{" "}
              <span className="font-bold">
                {ParseDateString({
                  timeString: allowedAfter,
                  timezone: userTZ,
                  userTZ: userTZ,
                  showAbbreviation: true
                })}
              </span>
              .
            </>
          ) : (
            "."
          )}
        </p>

        {/* {allowedAfter && (
          <p className="mt-3 text-primary text-base">
            Your next attempt will be available on{" "}
            <span className="font-bold">
              {ParseDateString({
                timeString: allowedAfter,
                timezone: userTZ,
                userTZ: userTZ,
                showAbbreviation: true
              })}
            </span>
            .
          </p>
        )} */}

        {/* {allowedAfter && (
          <p className="text-primary text-base">
            {diffHours < 24 ? (
              <>
                Please check back in{" "}
                <span className="font-bold">{allowedMoment.fromNow(true)}</span>
                .
              </>
            ) : (
              <>
                Please return after the above time to start your next attempt.
              </>
            )}
          </p>
        )} */}
      </div>
    </div>
  );
};

export default CoolOffPeriodScreen;
